export function getSubdomain<T extends Record<string, string>>(
  enumType: T
): T[keyof T] | null;

export function getSubdomain<T extends Record<string, string>>(
  enumType: T,
  fallback: T[keyof T]
): T[keyof T];

export function getSubdomain<T extends Record<string, string>>(
  enumType: T,
  fallback?: T[keyof T]
): T[keyof T] | null {
  const hostname = window.location.hostname;
  const [possibleSubdomainA, possibleSubdomainB] = hostname
    .toLowerCase()
    .split('.');

  const enumValues = Object.values(enumType) as T[keyof T][];

  const possibleSubdomainsCorrect: boolean = enumValues.some(
    (enumValue) =>
      enumValue === possibleSubdomainA || enumValue === possibleSubdomainB
  );

  if (possibleSubdomainsCorrect) {
    return (
      possibleSubdomainA !== 'www' ? possibleSubdomainA : possibleSubdomainB
    ) as T[keyof T];
  }

  if (fallback !== undefined) {
    return fallback;
  }

  return null;
}
